import {
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  AfterViewInit,
} from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[dateInputMask]",
})
export class DateInputMaskDirective implements OnInit, AfterViewInit {
  private mask = "__/__/____";

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl,
  ) {}

  ngOnInit() {
    this.initializeMask();
  }

  ngAfterViewInit() {
    if (this.control && this.control.control) {
      this.control.control.valueChanges.subscribe((val) => {
        if (!val || val === "") {
          this.initializeMask();
        }
      });
    }
  }

  private initializeMask() {
    const input = this.el.nativeElement;
    if (!input.value || input.value.length === 0) {
      if (this.control && this.control.control) {
        if (this.control.getError("required")) {
          const controlErrors = this.control.errors;
          this.control.control.setErrors({ ...controlErrors, invalid: true });
        }
      }

      this.setCursorToFirstUnderscore();
    }
  }

  private setCursorToFirstUnderscore() {
    const input = this.el.nativeElement;
    const pos = input.value.indexOf("_");
    const cursorPos = pos >= 0 ? pos : input.selectionStart;
    // setTimeout(() => input.setSelectionRange(cursorPos, cursorPos));
    input.setSelectionRange(cursorPos, cursorPos);
  }

  @HostListener("mousedown", ["$event"])
  @HostListener("touchstart", ["$event"])
  @HostListener("focus", ["$event"])
  @HostListener("click", ["$event"])
  onFocusOrClick() {
    this.setCursorToFirstUnderscore();
    this.control.control?.markAsTouched();
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    const input = this.el.nativeElement;
    let pos = input.selectionStart ?? 0;
    const value = input.value;
    const controlErrors = this.control.control?.errors;

    if (["ArrowLeft", "ArrowRight", "Tab"].includes(event.key)) return;

    this.control.control?.markAsDirty();

    if (
      value[pos] === "/" &&
      event.key !== "Backspace" &&
      event.key !== "Delete"
    ) {
      event.preventDefault();
      this.setCursorToNextInput(pos);
      return;
    }

    if (/^\d$/.test(event.key)) {
      event.preventDefault();

      let val = input.value;
      let cursorPos = input.selectionStart ?? 0;

      // Se l'input è completamente vuoto, inizializza la maschera
      if (!val || val.replace(/\D/g, "").length === 0) {
        val = this.mask;
        input.value = val;
        cursorPos = 0;
      }

      // Trova il primo underscore a destra del cursore
      let firstUnderscore = val.indexOf("_", cursorPos);
      if (firstUnderscore === -1) {
        return; // non ci sono underscore disponibili → blocca inserimento
      }

      // Inserisci il numero digitato al primo underscore disponibile
      input.value =
        val.substring(0, firstUnderscore) +
        event.key +
        val.substring(firstUnderscore + 1);

      // Posiziona il cursore subito dopo il numero inserito
      this.setCursorToNextInput(firstUnderscore + 1);

      this.updateFormControlIfComplete(input.value);
      return;
    }

    if (event.key === "Backspace") {
      event.preventDefault();
      if (pos === 0) return;
      let newPos = pos - 1;
      while (newPos > 0 && value[newPos] === "/") newPos--;
      input.value =
        value.substring(0, newPos) + "_" + value.substring(newPos + 1);
      this.setCursorToNextInput(newPos);

      const allUnderscore = input.value.replace(/\D/g, "").length === 0;
      const incomplete = input.value.replace(/\D/g, "").length > 0;

      // Controlla se l'input è completamente vuoto (tutti gli underscore) o incompleto
      if (
        (allUnderscore || incomplete) &&
        this.control &&
        this.control.control
      ) {
        this.control.control.setErrors({ ...controlErrors, invalid: true });
        if (allUnderscore) {
          this.control.control.setValue(null, { emitEvent: false });
          this.setCursorToFirstUnderscore();
        }
      }
      return;
    }

    if (event.key === "Delete") {
      event.preventDefault();
      if (pos >= value.length) return;
      while (pos < value.length && value[pos] === "/") pos++;
      input.value = value.substring(0, pos) + "_" + value.substring(pos + 1);
      this.setCursorToNextInput(pos);
      return;
    }

    event.preventDefault();
  }

  private setCursorToNextInput(pos: number) {
    const input = this.el.nativeElement;
    while (pos < input.value.length && input.value[pos] === "/") pos++;
    // setTimeout(() => input.setSelectionRange(pos, pos));
    input.setSelectionRange(pos, pos);
  }

  private updateFormControlIfComplete(val: string) {
    if (!val.includes("_")) {
      const [day, month, year] = val.split("/");
      const d = parseInt(day, 10);
      const m = parseInt(month, 10);
      const y = parseInt(year, 10);
      if (d > 0 && d <= 31 && m > 0 && m <= 12 && y >= 1900) {
        const dateObj = new Date(y, m - 1, d);
        if (this.control && this.control.control) {
          this.control.control.setValue(dateObj);

          const controlErrors = this.control.control.errors;
          controlErrors && delete controlErrors["invalid"];

          if (!controlErrors) {
            this.control.control.setErrors(null);
          } else {
            this.control.control.setErrors({ ...controlErrors });
          }
        }
      }
    } else {
      if (this.control && this.control.control) {
        const controlErrors = this.control.control.errors;
        this.control.control.setErrors({ ...controlErrors, invalid: true });
      }
    }
  }
}
